export default "__VITE_ASSET__79R4SsO1__"